<div [class.dark-theme]="codigrateSurface?.appearance === 'Dark' || (darkLightSetting === 'dark' && codigrateSurface?.appearance !== 'Light')"
     [class.light-theme]="codigrateSurface?.appearance === 'Light' || (darkLightSetting === 'light' && codigrateSurface?.appearance !== 'Dark')"
     [class]="setTheme()"
     [class.codigrate-skin]="!!codigrateSurface"
     [style.--theme-color]="codigrateSurface?.pluginPrimary || productTheme?.primary || null"
     [style.--theme-color-secondary]="codigrateSurface?.pluginSecondary || productTheme?.secondary || null"
     [style.--theme-color-tertiary]="codigrateSurface?.tertiaryColor || productTheme?.tertiary || null"
     [style.--codigrate-editor-bg]="codigrateSurface?.editorBackground || null"
     [style.--codigrate-window-bg]="codigrateSurface?.windowBackground || null"
     [style.--codigrate-surface]="codigrateSurface?.surface || null"
     [style.--codigrate-input-bg]="codigrateSurface?.inputBackground || null"
     [style.--codigrate-fg]="codigrateSurface?.primaryForeground || null"
     [style.--codigrate-fg-dim]="codigrateSurface?.secondaryForeground || null"
     [style.--codigrate-hover]="codigrateSurface?.hover || null"
     [style.--codigrate-error]="codigrateSurface?.error || null"
     [style.--codigrate-warning]="codigrateSurface?.warning || null"
     [style.--codigrate-info]="codigrateSurface?.info || null"
     [style.--codigrate-success]="codigrateSurface?.success || null"
     id="app-component">
  <!-- Mobile-only status-bar strip on every page (all layouts): colours the iOS
       top safe-area with the window background; the filler offsets page content. -->
  <div class="mobile-top-bar"></div>
  <div class="mobile-top-bar-filler"></div>
  <router-outlet></router-outlet>

  <!-- Cookie consent toast at the app root (NOT inside a routed page): a fixed bar
       nested in the home page's animation-heavy DOM had its text composited away
       on iOS Safari when the download counter / theme wall repainted (worse on
       prod, where the counter animates real numbers). As a sibling of
       <router-outlet> it is decoupled from any page's repaints. -->
  <app-cookies></app-cookies>

  <!-- Offers to match the site skin to the visitor's active Codigrate Chrome
       theme (via the All In One Themes extension). Also a root sibling so its
       text survives iOS Safari repaints, like the cookie toast above. -->
  <app-theme-offer></app-theme-offer>
</div>
